import { InjectionToken } from "@angular/core";
import { EnvironmentType } from "./environment-type.enum";

export type Environment = "dev" | "stg" | "prd";

interface BotConfig {
  env: Environment;
  sendMessageEndpoint: string;
  apiKey: string;
  apiKeyWs: string;
  wsRealTimeEndpoint: string;
  wsEndpoint: string;
  subscriptionAtributes: string;
}

interface ConversationVisualizerBotConfig {
  env: string;
  apiUrl: string;
  apiKey: string;
}

export interface EnvironmentConfig {
  production: boolean;
  baseApiUrl: string;
  name: string;
  env: EnvironmentType;
  mockAuth: boolean;
  chat: {
    dev: {
      [botId: string]: BotConfig;
    };
    stg: {
      [botId: string]: BotConfig;
    };
    prd: {
      [botId: string]: BotConfig;
    };
  };
  conversationVisualizer: {
    [env: string]: {
      [botId: string]: ConversationVisualizerBotConfig;
    };
  };
  automatedTesting: {
    dev: {
      env: Environment;
      apiUrl: string;
      apiKey: string;
    };
    stg: {
      env: Environment;
      apiUrl: string;
      apiKey: string;
    };
    prd: {
      env: Environment;
      apiUrl: string;
      apiKey: string;
    };
  };
}

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>("chat");
